export default "__VITE_ASSET__07a73e46__"